import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';

//Эти данные сервер сам выбирает из анкет на 1м и 2м шагах
interface IMeta {
  //Обязательные
  inviteManager: boolean;
  passedStage: string;
  //Не используются
  notifyByPhone?: boolean;
  notifyByEmail?: boolean;
  actualAddressMatch?: boolean;
}
interface IResponseMeta {
  key: string;
  value: any;
}

class Meta implements IMeta {
  inviteManager: boolean;
  passedStage: string;
  //Не используются
  // notifyByPhone: boolean;
  // notifyByEmail: boolean;
  // actualAddressMatch: boolean;
  constructor({
    inviteManager = false,
    passedStage = '',
    // notifyByPhone = false,
    // notifyByEmail = false,
    // actualAddressMatch = false,
  } = {}) {
    this.inviteManager = inviteManager;
    this.passedStage = passedStage;
    // this.notifyByPhone = notifyByPhone;
    // this.notifyByEmail = notifyByEmail;
    // this.actualAddressMatch = actualAddressMatch;
  }
}
interface IMetaState {
  meta: IMeta;
}

export default <Module<IMetaState, any>>{
  state: {
    meta: new Meta(),
  },
  mutations: {
    setMeta(state, data: IMeta) {
      state.meta = new Meta(data);
    },
  },
  actions: {
    async getMeta({ commit, dispatch, rootGetters }, id: string = rootGetters.appId): Promise<number> {
      return axios
        .get<IResponseMeta[]>(rootGetters.uri.meta(id))
        .then((resp) => {
          if (resp.data instanceof Array && resp.data.length) {
            const meta = <IMeta>resp.data.reduce((sum, item) => {
              //@ts-ignore
              sum[item.key] = item.value;
              return sum;
            }, {});

            commit('setMeta', meta);
            //todo response возвращает {key: "passedStage"; value: string;}, а должен {key: "passedStage"; value: number;}
            if (meta.passedStage) {
              const step = +meta.passedStage
              commit('setAppStep', step, { root: true });
              return step;
            }
          }
          return 1;
        })
        .catch((e) => {
          e.uri = rootGetters.uri.meta(id);
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async getApplicationStepWithMeta({ dispatch, rootGetters }, id: string = rootGetters.appId): Promise<number> {
      return await dispatch('getMeta', id);
    },
  },
  getters: {
    meta: (state): IMeta => state.meta,
  },
};
